import React from "react";
import { Typography } from 'antd';
const { Title } = Typography;

export default function TitleText(props) {
    return (
        <Title level={props.level} className={"main-title "+ (props.className ? props.className : '')}>{props.text}</Title>
    );
}